import React from 'react';
import { motion } from 'framer-motion';
import experiencevideo from '../assets/experience.mp4';

const ExperienceSection = () => {
  return (
    <section
      className="bg-[#fdfbf7] py-16 px-6"
      style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}
    >
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Video Section */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: false, amount: 0.3 }}
          className="flex justify-center"
        >
          <video
            src={experiencevideo}
            height={250}
            width={350}
            autoPlay
            muted
            loop
            playsInline
            controls
            className="rounded-xl shadow-lg"
          />
        </motion.div>

        {/* Text Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h2 className="text-xl text-gray-800 font-normal" style={{ fontSize: '32px' }}>
            Safari<br />Experience & Retreat
          </h2>
          <p className="text-gray-700 text-base sm:text-lg leading-relaxed"
  style={{ fontSize: '16px' }}><br />
            For those who want to slow down and connect deeply with the horses and the land, our Stable Stay offers a grounded, heartfelt experience. <br /><br />
            Live alongside the horses at our Ashwalaya farm and take part in the rituals of traditional horse care—from feeding and grooming to riding lessons and bonding exercises. <br /><br />
            Between rides, enjoy fresh farm-cooked meals and an introduction to rural Marwari life.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ExperienceSection;
